import React, { Component } from 'react'
import { store } from '../../redux/store';
import { connect } from 'react-redux';
import { SET_PAGE_TITLE, SET_EMAIL_LIST, SET_REPORT_LIST } from '../../redux/types';
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import { cardTitle, roseColor } from "assets/jss/material-dashboard-pro-react.jsx";
import { cleanReportName } from '../../helpers';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";

import { withStyles, IconButton, Fab } from '@material-ui/core';
import { Add, Check } from '@material-ui/icons'

import Api from '../../api/Api.js';
import EmailEndpoints from '../../api/EmailEndpoints';
import ReportEndpoints from '../../api/ReportEndpoints';
import ReactSelect from '../../components/Select/ReactSelect';
import DataTable from '../../components/Table/DataTable';
import Loading from '../../components/Loading/Loading';

import EmailDialog from '../Reports/EmailDialog';

const styles = {
    cardTitle,
    cardTitleWhite: {
        ...cardTitle,
        color: "#FFFFFF",
        marginTop: "0"
    },
    cardCategoryWhite: {
        margin: "0",
        color: "rgba(255, 255, 255, 0.8)",
        fontSize: ".875rem"
    },
    cardCategory: {
        color: "#999999",
        marginTop: "10px"
    },
    icon: {
        color: "#333333",
        margin: "10px auto 0",
        width: "130px",
        height: "130px",
        border: "1px solid #E5E5E5",
        borderRadius: "50%",
        lineHeight: "174px",
        "& svg": {
            width: "55px",
            height: "55px"
        },
        "& .fab,& .fas,& .far,& .fal,& .material-icons": {
            width: "55px",
            fontSize: "55px"
        }
    },
    iconRose: {
        color: roseColor
    },
    marginTop30: {
        marginTop: "30px"
    },
    testimonialIcon: {
        marginTop: "30px",
        "& svg": {
            width: "40px",
            height: "40px"
        }
    },
    cardTestimonialDescription: {
        fontStyle: "italic",
        color: "#999999"
    }
};

const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Address",
        options: {
            filter: true,
            sort: true,
        }
    }
]

const verifyEmail = (value) => {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
        return true;
    }
    return false;
}

class ManageEmails extends Component {

    constructor(props) {
        super(props);
        
        store.dispatch({ type: SET_PAGE_TITLE, payload: "Manage Emails" })

        this.state = {           
            selectedReport: { label: 'None', value: '' },
            loading: (props.reports && props.reports.length > 0),
            saving: false
        }
    }

    addEmail(email) {
        Api.get(EmailEndpoints.add, { email })
            .then(({ data }) => {
                store.dispatch({ type: SET_EMAIL_LIST, payload: this.props.emails.concat([data]) })
            });
    }

    getReportEmails = (id) => {
        console.log(`Getting Detail for Report ${id}`)
        this.setState({ loading: true });
        Api.get(ReportEndpoints.detail, { id })
            .then(({ data }) => {
                this.setState({ 
                    loading: false, 
                    selectedReport: { 
                        ...this.state.selectedReport, 
                        id,
                        emails: data.emails.map(e => ({ label: e.emailaddress, value: e.id }))
                    }});                                            
                console.log(data);
            })
            .catch((e) => {
                this.setState({ loading: false });
                console.error(e);
            })
    }


    renderSaveButton = () => {          
        if (!this.state.saving) {
          const { classes } = this.props;
          return (
              <Fab 
                  style={{ 
                      float: 'right', 
                      display: this.state.selectedReport.id ? 'block' : 'none'
                    }}                   
                  variant="extended" 
                  className={classes.button} 
                  color="primary" 
                  onClick={() => { 
                      this.setState({ saving: true }, () => {
                        Api.post(ReportEndpoints.updateEmails, 
                            { emails: this.state.selectedReport.emails.map((e) => ({ id: e.value, emailaddress: e.label })), id: this.state.selectedReport.id })
                              .then(() => {
                                  this.props.close();
                                  this.props.refresh({ ...this.state });
                                  this.setState({ saving: false })
                              })
                            .catch((e) => this.setState({ loading: false }, () => console.error(e)))
                                this.setState({ saving: false });
                      });
                   }} 
              >
                  Save Changes<Check style={{ marginLeft: 10 }} /> 
              </Fab>
          );
        }
  
        return(
          <div style={{ float: 'right' }} ><Loading /></div>
        );
    }

    componentDidMount() {
        Api.get(ReportEndpoints.list)
            .then(({ data }) => {
                store.dispatch({ type: SET_REPORT_LIST, payload: data });
                Api.get(EmailEndpoints.list)
                .then(({ data }) => {
                    this.setState({ loading: false }, () => {
                        store.dispatch({ type: SET_EMAIL_LIST, payload: data })
                    });
                })
                .catch((e) => {
                    console.error(e);
                })
            })
            .catch((e) => {
                console.error(e);
            })

       
    }

    render() {
        const { emails, reports, classes } = this.props;

        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                    <Card>
                        <CardHeader color="success" text>
                            <CardText color="success">
                                <h4 className={classes.cardTitleWhite}>Manage Emails</h4>
                            </CardText>
                        </CardHeader>
                        <CardBody>
                            <ReactSelect
                                options={
                                    reports && reports.length > 0 ?
                                        [{ label: 'None', value: '' }].concat(reports.map(rep => ({ label: cleanReportName(rep.name), value: rep.id })))
                                        :
                                        [{ label: 'None', value: '' }]
                                }
                                onChange={(value) => {                                   
                                    var report = reports.find(x => x.id === value.value);                                    

                                    if (report) {
                                        this.setState({ selectedReport: value })
                                        this.getReportEmails(report.id);
                                    }
                                    else
                                        this.setState({ selectedReport: { label: 'None', value: '' }});
                                }
                                }
                                placeholder="Please Select a Report..."
                                value={this.state.selectedReport}
                                isSearchable
                                isLoading={this.state.loading}
                                isDisabled={this.state.loading}
                            />
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>                            
                            <EmailDialog
                                isOpen={this.state.showAddEmailDialog}
                                close={() => this.setState({ showAddEmailDialog: false })}
                                CreateEmail={(email) => this.addEmail(email)}
                            />
                            <div style={{ flex: 1, display: this.state.selectedReport.id ? 'block' : 'none' }}>
                                <ReactSelect
                                    label="Email Recipients"
                                    options={
                                        this.props.emails && this.props.emails.length > 0 ?
                                        this.props.emails.map(e => ({ label: e.emailaddress, value: e.id }))
                                            :
                                            [{ label: 'Loading...', value: '' }]
                                    }
                                    onChange={(value) => { 
                                        console.log(value);
                                        this.setState({ selectedReport: { ...this.state.selectedReport, emails: value } });
                                    }}
                                    isValidNewOption={verifyEmail}
                                    onCreateOption={(new_email) => {
                                        Api.get(EmailEndpoints.add, { email: new_email })
                                            .then(({ data }) => {
                                                this.setState({ selectedReport: this.state.selectedReport.emails.concat([{ label: data.emailaddress, value: data.id }]) }, 
                                                (email) => store.dispatch({ type: SET_EMAIL_LIST, payload: this.props.emails.concat([email]) }));                                                
                                            });
                                    }}
                                    
                                    placeholder="No Emails Selected"
                                    value={this.state.selectedReport.emails}
                                    isCreateable
                                    isClearable
                                    isSearchable
                                    isMulti
                                    isLoading={!emails || emails.length === 0}
                                    isDisabled={!emails || emails.length === 0}
                                />
                            </div>
                            <IconButton 
                                style={{ display: this.state.selectedReport.id ? 'block' : 'none' }} 
                                onClick={() => this.setState({ showAddEmailDialog: true })}>
                                <Add />
                            </IconButton>
                        </div>
                        </CardBody>
                    </Card>
                    {this.renderSaveButton()}
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <DataTable
                        title={"Email Addresses"}
                        data={
                            emails.map(em => [em.id, em.emailaddress])
                        }
                        columns={columns}
                        options={{
                            onRowClick: (row) => {
                                if (!this.state.selectedReport.emails) return;
                                var selectedEmail = this.state.selectedReport.emails.find(x => x.value == row[0]);     
                                if (!selectedEmail) {
                                    this.setState({ 
                                        selectedReport: { 
                                            ...this.state.selectedReport, 
                                            emails: [ ...this.state.selectedReport.emails, { label: row[1], value: row[0] } ]
                                        } 
                                    });
                                    console.log(selectedEmail);                           
                                }
                            }
                        }}
                        rowPointers
                    />
                </GridItem>
            </GridContainer>
        )
    }
}

const mapStateToProps = ({ reports, emails }) => ({ reports: reports.list, emails: emails.list })

export default withStyles({ ...extendedFormsStyle, ...styles })(connect(mapStateToProps)(ManageEmails));